import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_CIVILOPNAME,
  DELETE_CIVILOPNAME,
  UPDATE_CIVILOPNAME,
  ADD_NEW_CIVILOPNAME,
} from "./actionType";

import {
  getCivilOpnameSuccess,
  getCivilOpnameFail,
  deleteCivilOpnameSuccess,
  deleteCivilOpnameFail,
  updateCivilOpnameSuccess,
  updateCivilOpnameFail,
  addCivilOpnameSuccess,
  addCivilOpnameFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  getCivilOpnameApi,
  updateCivilOpnameApi,
  deleteCivilOpnameApi,
  addNewCivilOpnameApi,
  approveCivilOpnameApi
} from "../../helpers/backend_helper";

function* getCivilOpname({ payload: civilOpname }) {
  try {
    const response = yield call(getCivilOpnameApi, civilOpname);
    yield put(getCivilOpnameSuccess(GET_CIVILOPNAME, response.data));
  } catch (error) {
    yield put(getCivilOpnameFail(GET_CIVILOPNAME, error));
  }
}

function* onUpdateCivilOpname({ payload: civilOpname }) {
  try {
    if (civilOpname.setApprove) {
      const response = yield call(approveCivilOpnameApi, civilOpname);
      yield put(updateCivilOpnameSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateCivilOpnameApi, civilOpname);
      yield put(updateCivilOpnameSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateCivilOpnameFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteCivilOpname({ payload: civilOpname }) {
  try {
    const response = yield call(deleteCivilOpnameApi, civilOpname);
    yield put(deleteCivilOpnameSuccess({ civilOpname, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteCivilOpnameFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewCivilOpname({ payload: civilOpname }) {
  try {
    const response = yield call(addNewCivilOpnameApi, civilOpname);
    yield put(addCivilOpnameSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addCivilOpnameFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetCivilOpname() {
  yield takeEvery(GET_CIVILOPNAME, getCivilOpname);
}

export function* watchUpdateCivilOpname() {
  yield takeEvery(UPDATE_CIVILOPNAME, onUpdateCivilOpname);
}

export function* watchDeleteCivilOpname() {
  yield takeEvery(DELETE_CIVILOPNAME, onDeleteCivilOpname);
}

export function* watchAddNewCivilOpname() {
  yield takeEvery(ADD_NEW_CIVILOPNAME, onAddNewCivilOpname);
}

function* civilOpnameSaga() {
  yield all([
    fork(watchGetCivilOpname),
    fork(watchDeleteCivilOpname),
    fork(watchUpdateCivilOpname),
    fork(watchAddNewCivilOpname)
  ]);
}

export default civilOpnameSaga;
